module.exports = __webpack_public_path__ + "static/media/0028_IMG_L_ESPACE_RESTAURATION_MAIL.aea30aa2.png";